// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3hANy","title":"ClientCherryInfo_title__Z-X5s","itemText":"ClientCherryInfo_itemText__wZlF2"};